/*
 * Copyright (c) 2024 CalAmp Corp. All Rights Reserved
 */
import {QueryChipData} from '../types';
import {NO_GROUP_ID} from './constants';

/**
 * Checks if there is no active group filter in the provided array of active queries.
 * @param activeQueries - An array of active queries.
 * @returns A boolean indicating whether there is no active group filter.
 */
export const validateGroupFilterActive = (activeQueries: QueryChipData[]): boolean => {
  return activeQueries?.some(({value}) => value?.id === NO_GROUP_ID);
};
